export default __webpack_public_path__ + "static/media/ralph-waldo-emerson.cbcd64b5.png";